import React, { useState } from "react";
import { Button } from "@amzn/awsui-components-react";
import { downloadFirstPassResults } from "../pdfUtils";

const DownloadResultsButton = ({ data }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!data) return;
    await downloadFirstPassResults(
      data,
      () => setIsDownloading(true),
      () => setIsDownloading(false),
      'rich'
    );
  }

  return (
    <Button
      iconName="download"
      variant="icon"
      onClick={handleDownload}
      disabled={isDownloading}
      loading={isDownloading}
    />
  );
};

export default DownloadResultsButton;
